import { render, staticRenderFns } from "./Nvabar.vue?vue&type=template&id=3f875568&scoped=true&"
import script from "./Nvabar.vue?vue&type=script&lang=js&"
export * from "./Nvabar.vue?vue&type=script&lang=js&"
import style0 from "./Nvabar.vue?vue&type=style&index=0&id=3f875568&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f875568",
  null
  
)

export default component.exports